import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "../styles/AvailableTestCards.scss";

const AvailableTestCards = ({ tests }) => {
  const navigate = useNavigate();

  const checkTestCompletion = (testType) => {
    const storedUser = Cookies.get("user");

    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);

        if (testType === "iq") {
          return parsed?.iqTest_completed === true;
        } else if (testType === "psychometric") {
          return parsed?.psychometricTest_completed === true;
        }
      } catch (e) {
        console.error("Error parsing user data:", e);
      }
    }

    return false;
  };

  const handleStartTest = (testId) => {
    navigate(`/test?test_id=${testId}`);
  };

  if (!tests || tests.length === 0) {
    return (
      <div className="available-tests-container">
        <div className="no-tests-message">
          <h2>No Tests Available</h2>
          <p>There are currently no tests available for you to take.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="available-tests-container">
      <div className="tests-header">
        <h2>Available Tests</h2>
        <p>Please select a test to begin your assessment.</p>
      </div>

      <div
        className={`test-cards-grid ${
          tests.length === 1
            ? "single-card"
            : tests.length === 2
              ? "two-cards"
              : ""
        }`}
      >
        {tests.map((test) => {
          const isCompleted = checkTestCompletion(test.test_type);

          return (
            <div
              key={test.id}
              className={`test-card ${isCompleted ? "completed" : ""}`}
            >
              <div className="test-card__header">
                <h3>{test.name}</h3>
                <span className={`test-type ${test.test_type}`}>
                  {test.test_type?.toUpperCase() || "TEST"}
                </span>
              </div>

              <div className="test-card__meta">
                <div className="meta-item">
                  <span className="meta-label">Duration</span>
                  <span className="meta-value">{test.duration} minutes</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Questions</span>
                  <span className="meta-value">{test.questions_count}</span>
                </div>
              </div>

              <div className="test-card__description">
                <p>
                  {test.test_type === "iq"
                    ? "Assess your cognitive abilities and problem-solving skills."
                    : test.test_type === "psychometric"
                      ? "Evaluate your personality traits and behavioral patterns."
                      : "Complete this assessment to evaluate your skills."}
                </p>
              </div>

              {isCompleted ? (
                <div className="completed-badge-container">
                  <span className="completed-text">Test Completed</span>
                </div>
              ) : (
                <button
                  className="btn-start-test"
                  onClick={() => handleStartTest(test.id)}
                >
                  Start Test
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AvailableTestCards;
